import type { Platform } from '@app-iptv/shared'

import { detectPlatformInfo } from './platform'
import { detectAutoTier, detectTier as detectTierImpl, getTierOverride, setTierOverride } from './tier'

export { setTierOverride, getTierOverride, detectAutoTier }
export { quickBenchmark } from './benchmark'
export {
  measureBandwidth,
  getCachedBandwidth,
  clearBandwidthCache,
  type BandwidthResult,
  type BandwidthClass,
  type ProbeProgress,
  type MeasureOptions,
} from './bandwidth'
export { getDeviceId, getMacAddress, generateUuidV4, type DeviceIdInfo } from './device-id'

// ===== Capabilities (substituindo tier cru — recomendado pra novos callers) =====
export {
  getCapabilities,
  getCapability,
  refreshCapabilities,
  subscribeCapabilities,
  VOD_PREFETCH_OVERRIDE_KEY,
  type DeviceCapabilities,
  type AnimationLevel,
  type LongSessionMode,
} from './capabilities'

// Banda de tier por plataforma/motor. Exportado porque o script inline de
// boot do `apps/tv/index.html` DUPLICA esta regra (roda antes do bundle, pra
// pintar o 1º frame no tier certo) e `apps/tv/src/boot-tier.test.ts` prova a
// paridade entre os dois. Sem isso, as cópias divergem e o tier PISCA no boot.
export {
  platformTierBand,
  clampTierToBand,
  parsePlatformMajor,
  canPlayNativeTs,
  canPrefetchVod,
  VOD_PREFETCH_DEFAULT_BY_PLATFORM,
  type TierBand,
  type PlatformTierInput,
} from './platform-tier'

// Leitura da API NATIVA da TV (webOS `PalmSystem`/Luna, Tizen `systeminfo`).
// `getNativePlatformInfo` serve diagnóstico/telemetria (modelo, firmware).
export {
  getNativePlatformInfo,
  loadNativePlatformInfo,
  type NativePlatformInfo,
} from './platform-native'

export {
  initSignals,
  getSignals,
  refreshNetworkSignal,
  setLastMeasuredMbps,
  subscribeNetwork,
  type DeviceSignals,
  type CpuSignal,
  type CpuTier,
  type RamSignal,
  type RamTier,
  type StorageSignal,
  type StorageTier,
  type ViewportSignal,
  type ViewportTier,
  type NetworkSignal,
  type NetworkClass,
  type FeaturesSignal,
} from './signals'

export function detectPlatform(): Platform {
  return detectPlatformInfo().platform
}

/**
 * @deprecated Use `getCapability(key)` ou `useCapability(key)` (React).
 * Mantido pra retro-compat durante migração das ondas. Internamente vira
 * `getCapability('cpuTier')`.
 *
 * `detectTier()` retorna single-axis. `getCapabilities()` é granular —
 * cada decisão tem sua própria capability. Ver `docs/specs/roadmap-pos-mvp.md` §4.
 */
export function detectTier() {
  return detectTierImpl()
}
